import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Series from '../Series';
import useChart from '../UseChart';

var BarSeries = function BarSeries(props) {
  var chart = useChart();
  useEffect(function () {
    chart.update({
      chart: {
        inverted: true
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Series, _extends({}, props, {
    type: "bar"
  }));
};

export default BarSeries;